import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-projeto-urbanistico',
  templateUrl: './projeto-urbanistico.component.html',
  styleUrls: ['./projeto-urbanistico.component.scss'],
})
export class ProjetoUrbanisticoComponent { }
